import { render, staticRenderFns } from "./AssignRecord.vue?vue&type=template&id=8668d1f0"
import script from "./AssignRecord.vue?vue&type=script&lang=js"
export * from "./AssignRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports